/**
 * PixiJS Stage scaffold (spec §2, §4.6).
 *
 * M5 intentionally uses DOM placeholders for characters/cards — jsdom
 * has no WebGL, and the MVP idle animations are just `transform: scale`
 * on DOM elements (spec §4.6 L268). This module exports a thin wrapper
 * so v2 can drop real PixiJS sprites in without touching routes.
 *
 * v2 task list:
 *   - Mount `<Application>` from @pixi/react here.
 *   - Render sprite-sheet characters + animated idle/thinking states.
 *   - Bridge click events to the existing React action bar.
 */
import type { ReactNode } from 'react';

export type PixiStageProps = {
  children?: ReactNode;
  /** Applied to the root wrapper — tests use this to locate the stage. */
  testId?: string;
};

export function PixiStage({ children, testId = 'pixi-stage' }: PixiStageProps) {
  return (
    <div className="relative w-full h-full" data-testid={testId}>
      {children}
    </div>
  );
}
